import { useSearchParams } from 'react-router-dom';
import { 
    Col,
    Row,
    Button,    
    Card,
    Alert,
    Layout,
    Content
} from '@servahealth/serva-ui-kit';
import LoginHeader from './LoginHeader';
import { ConfigProvider } from 'antd';
import bgimg from '../../images/ContactUs-bg.png'

/**
 * Landing page for when SSO expiry occurs and user needs to refresh the token by navigating back to where they came from first
 */
const Landing = () => {
    const [params] = useSearchParams();
    const redirect_uri = params.get('redirect_uri');
    const handleRedirect = () => {
        window.location = redirect_uri;
    }

    return (
        <ConfigProvider 
            theme={{
                token: {
                    colorPrimary: '#009ee2'
                }
            }}
        >
            <Layout style={{ minHeight: '100vh', backgroundImage: `url(${bgimg})` }}>
                <Content>
                    <Row type="flex" justify="center" align="middle">
                        <Col xs={22} sm={15} md={9} xl={7} xxl={5}>
                            <Card className="text-center mt-5" bodyStyle={{ paddingBottom: 10 }}>
                                <LoginHeader key={params.get('client_id')} clientId={params.get('client_id') ?? ''} />
                                {!!params.get('reason') && params.get('reason') !== '' && <Alert showIcon message={params.get('reason')} type='info' />}
                                {!!redirect_uri && <Button
                                    type="primary"
                                    onClick={handleRedirect}
                                    block
                                    className='my-4'
                                >
                                    Continue to Sign-in
                                </Button>}
                            </Card>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        </ConfigProvider>
    );
};

export default Landing;
